// removed by extract-text-webpack-plugin
module.exports = {"Container":"SelectableBoxList__Container__3onQF","Header":"SelectableBoxList__Header__3W6aI","List":"SelectableBoxList__List__u-NZt","ContentBox":"SelectableBoxList__ContentBox__jup1R"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/SelectableBoxList/SelectableBoxList.css
// module id = 1267
// module chunks = 2